import React, { Component } from 'react';
import './style.sass';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import CommonTitle from '../../../common-components/common-title';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonUsualText from '../../../common-components/common-usual-text';
import CommonSmallText from '../../../common-components/common-small-text';

const list = [
    {
        showDataTitle: '1',
        showDataSubtitle: 'видеоролик создали',
    },
    {
        showDataTitle: '22',
        showDataSubtitle: 'инфографика разработали',
    },
    {
        showDataTitle: '13',
        showDataSubtitle: 'презентаций сделали',
    },
    {
        showDataTitle: '18 246',
        showDataSubtitle: 'новостей перенесли',
    },
];

class Results extends Component {
    render() {
        return (
            <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1.5}>
                <FullWrapper className="zkhfoundation-results" smallPaddings={true}>
                    <CommonTitle>Результаты</CommonTitle>
                    <ScrollAnimation
                        animateIn="fadeIn"
                        offset={100}
                        animateOnce={true}
                        duration={1.5}
                    >
                        <CommonUsualText className="zkhfoundation__text-info">
                            Мы&nbsp;полностью обновили бренд Фонда ЖКХ, сайт и&nbsp;систему
                            управления сайтом, помогли клиенту наглядно донести пользователям
                            информацию о&nbsp;главных направлениях работы и&nbsp;их&nbsp;пользе
                            и&nbsp;все успели в&nbsp;срок.
                        </CommonUsualText>
                    </ScrollAnimation>
                    <div className="zkhfoundation-ciphers">
                        <div className="zkhfoundation-ciphers__wrapper">
                            <div className="zkhfoundation-results-ciphers__grid">
                                {list.map(({ showDataTitle, showDataSubtitle }, index) => (
                                    <ScrollAnimation
                                        animateIn="fadeInUp"
                                        offset={0}
                                        delay={100}
                                        animateOnce={true}
                                        duration={1}
                                        className="zkhfoundation-results-ciphers__item"
                                        key={index}
                                    >
                                        <div className="zkhfoundation-results-ciphers__item-wrap">
                                            <div className="zkhfoundation-results-ciphers__name">
                                                {showDataTitle}
                                            </div>
                                            <CommonSmallText className="zkhfoundation-results-ciphers__desc">
                                                {showDataSubtitle}
                                            </CommonSmallText>
                                        </div>
                                    </ScrollAnimation>
                                ))}
                            </div>
                        </div>
                    </div>
                </FullWrapper>
            </ScrollAnimation>
        );
    }
}

export default Results;
